import { createReducer } from 'reduxsauce';
import { produce } from 'immer';
import find from 'ramda/src/find';
import findIndex from 'ramda/src/findIndex';
import propEq from 'ramda/src/propEq';
import { DevelopTypes } from '~/actions';
import { removeStatus } from '~/services/util';
import { INITIAL_NOTIFICATION_SETTINGS } from '~/services/constants';

const TEMPLATES = {
    current_page: 1,
    data: [],
    last_page: 1,
    per_page: 10,
    total: 10,
};

const initialState = {
    status: [],

    templates: {
        trainings: TEMPLATES,
        assignments: TEMPLATES,

        tracks: TEMPLATES,
        courses: TEMPLATES,
        modules: TEMPLATES,

        careers: TEMPLATES,
        certifications: TEMPLATES,
        badges: TEMPLATES,

        powerpoint: TEMPLATES,
        word: TEMPLATES,
        pdf: TEMPLATES,
        esign: TEMPLATES,
        envelope: TEMPLATES,
        packets: TEMPLATES,
        excel: TEMPLATES,

        habits: TEMPLATES,
        // habitsschedules
        habitslist: TEMPLATES,
        quotas: TEMPLATES,
        scorecards: TEMPLATES,

        assessments: TEMPLATES,
        survey: TEMPLATES,
        review: TEMPLATES,
    },

    instances: {
        carryOvers: TEMPLATES,
        courses: TEMPLATES,
        habits: TEMPLATES,
        quotas: TEMPLATES,
        scorecards: TEMPLATES,
        programs: TEMPLATES,
        tracks: TEMPLATES,
        performances: TEMPLATES,
        habitslist: TEMPLATES,
        tasks: TEMPLATES,
        assigned: TEMPLATES,
        training: TEMPLATES,
        daily: { today: [], week: [], month: [] },
        dailyTraining: { open: [], completed: [] },
    },

    // Default notificationsSetting data for old/existing users whose notification setting could not be found
    notificationsSettings: INITIAL_NOTIFICATION_SETTINGS,

    // Deprecated reducers
    learnQuizQuestions: {
        num: 1,
        type: 1,
        options: [],
        title: '',
        completed: false,
        result: {},
        message: '',
    },
    learnQuizAnswers: {
        correct: 1,
        answer: '',
        error: false,
    },
    videoPlayStates: [],

    notificationToggle: [],

    libraryQuotaOptions: [],
    libraryCardTemplates: [],

    trainingScheduleDetail: null,

    selfsCoursesReport: [],
    careerCoursesReport: [],
    managerCoursesReport: [],

    teamReports: {
        self: {},
        career: {},
        manager: {},
        overall: {},
        users: {},
        individuals: {},
        companies: {},
    },
    trainingSchedules: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
        data: [],
    },

    careerPrograms: [],
    careerRequirements: [],
    careerHabits: [],
    careerDevelopments: [],
    careerGoals: [],
    careerTasks: [],
    careerTrainings: [],
    careerCurJobIndex: 0,
    careerJobs: [],
    careerPromotionCard: {},
    promoteStatus: '',
    careerMessage: '',
};

const getlearnfeedsRequest = produce((draft, action) => {
    // draft.status.push('pending-dlf')
});
const getlearnfeedsSuccess = produce((draft, action) => {
    const { type, data } = action.response;
    // draft.status = removeStatus('pending-dlf', draft.status)
    draft.instances[type] = data;
});
const getlearnfeedsFailure = produce((draft, action) => {
    // draft.status = removeStatus('pending-dlf', draft.status)
});

const postlibrarycardtemplatesRequest = produce((draft, action) => {
    draft.status.push('pending-dlt');
});
const postlibrarycardtemplatesSuccess = produce((draft, action) => {
    const { target, response } = action;
    const index = findIndex(propEq('id', response.id), draft.templates[target].data);
    draft.templates[target].data[index] = action.response;
    draft.status = removeStatus('pending-dlt', draft.status);
});
const postlibrarycardtemplatesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dlt', draft.status);
});

const getlibrarytemplatesRequest = produce((draft, action) => {
    draft.status.push('pending-dglt');
});
const getlibrarytemplatesSuccess = produce((draft, action) => {
    const { target, response } = action;
    response.forEach((item) => {
        const index = findIndex(propEq('id', item.id), draft.templates[target].data);
        if (index > -1) {
            draft.templates[target].data[index] = item;
        } else {
            draft.templates[target].data.push(item);
        }
    });
    draft.status = removeStatus('pending-dglt', draft.status);
});
const getlibrarytemplatesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dglt', draft.status);
});

const getlibrarytemplatessearchRequest = produce((draft, action) => {
    draft.status.push('pending-dts');
});
const getlibrarytemplatessearchSuccess = produce((draft, action) => {
    const { target, response } = action;
    draft.templates[target] = response;
    if (target === 'pdf') {
        draft.templates.esign = response;
        draft.templates.packets = response;
    }
    draft.status = removeStatus('pending-dts', draft.status);
});
const getlibrarytemplatessearchFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dts', draft.status);
});

const dailytrainingRequest = produce((draft, action) => {
    draft.status.push('pending-ddt');
});
const dailytrainingSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-ddt', draft.status);
    draft.instances.dailyTraining = action.response;
});
const dailytrainingFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ddt', draft.status);
});

const updatecardRequest = produce((draft, action) => {
    draft.status.push('pending-duc');
});
const updatecardSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-duc', draft.status);
});
const updatecardFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-duc', draft.status);
});

const getscormlinkRequest = produce((draft, action) => {
    draft.status.push('pending-dsl');
});
const getscormlinkSuccess = produce((draft, action) => {
    const { courseId, cardId, scormLink } = action;

    const courseIndex = findIndex(propEq('id', courseId), draft.instances.courses.data);
    const cardIndex = findIndex(propEq('id', cardId), draft.instances.courses.data[courseIndex].children);

    draft.instances.courses.data[courseIndex].children[cardIndex].data.en = draft.instances.courses.data[courseIndex].children[cardIndex].data.en || {};
    draft.instances.courses.data[courseIndex].children[cardIndex].data.en.link = scormLink;
    draft.instances.courses.data[courseIndex].children[cardIndex].data.link = scormLink;

    draft.status = removeStatus('pending-dsl', draft.status);
});
const getscormlinkFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dsl', draft.status);
});

/**
 * POST Scorecard Save
 * @param {*} draft
 * @param {*} action
 */
const postscorecardsaveRequest = produce((draft, action) => {
    draft.status.push('pending-dps');
});
const postscorecardsaveSuccess = produce((draft, action) => {
    const { scorecard } = action.response;
    const idx = findIndex(propEq('id', scorecard.id), draft.templates['scorecards'].data);
    if (idx > -1) {
        draft.templates['scorecards'].data[idx] = scorecard;
    } else {
        draft.templates['scorecards'].data.push(scorecard);
    }
    draft.status = removeStatus('pending-dps', draft.status);
});
const postscorecardsaveFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dps', draft.status);
});

const questionRequest = produce((draft, action) => {
    draft.status.push('pending-dqq');
    draft.learnQuizQuestions = {
        num: 1,
        type: 1,
        options: [],
        title: '',
        completed: false,
        result: {},
        message: '',
    };
    draft.learnQuizAnswers = { correct: 1, answer: '', error: false };
});
const questionSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dqq', draft.status);
    draft.learnQuizQuestions = action.response;
});
const questionFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dqq', draft.status);
});

const answerRequest = produce((draft, action) => {
    draft.status.push('pending-daa');
    draft.learnQuizAnswers = { correct: 1, answer: '', error: false };
});
const answerSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-daa', draft.status);
    draft.learnQuizAnswers = action.response;
});
const answerFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-daa', draft.status);
});

const resetquizRequest = produce((draft, action) => {
    draft.status.push('pending-drq');
    draft.learnQuizQuestions = {
        num: 1,
        type: 1,
        options: [],
        title: '',
        completed: false,
        result: {},
        message: '',
    };
    draft.learnQuizAnswers = { correct: 1, answer: '', error: false };
});
const resetquizSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-drq', draft.status);
});
const resetquizFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-drq', draft.status);
});

const updatemoduleRequest = produce((draft, action) => {
    draft.status.push('pending-dum');
});
const updatemoduleSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dum', draft.status);
});
const updatemoduleFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dum', draft.status);
});

const libraryeventRequest = produce((draft, action) => {
    draft.status.push('pending-dle');
});
const libraryeventSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dle', draft.status);
});
const libraryeventFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dle', draft.status);
});

const librarysaveRequest = produce((draft, action) => {
    draft.status.push('pending-dls');
});
const librarysaveSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dls', draft.status);
    const { response, mode } = action;
    const { quota_template } = response;
    if (mode === 'quota_template') {
        const idx = findIndex(propEq('id', quota_template.id), draft.templates.quotas.data);
        draft.templates.quotas.data[idx] = quota_template;
    }
});
const librarysaveFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dls', draft.status);
});

const libraryprogramdetailRequest = produce((draft, action) => {
    draft.status.push('pending-dlp');
});
const libraryprogramdetailSuccess = produce((draft, action) => {
    const { response, mode } = action;
    const idx = findIndex(propEq('id', response.id), draft.templates[mode].data);
    if (idx > -1) {
        draft.templates[mode].data[idx] = response;
    } else {
        draft.templates[mode].data.push(response);
    }
    draft.status = removeStatus('pending-dlp', draft.status);
});
const libraryprogramdetailFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dlp', draft.status);
});

const programpromotionRequest = produce((draft, action) => {
    draft.status.push('pending-dpp');
});
const programpromotionSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dpp', draft.status);
});
const programpromotionFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dpp', draft.status);
});

const quotatemplatesRequest = produce((draft, action) => {
    draft.status.push('pending-dqt');
});
const quotatemplatesSuccess = produce((draft, action) => {
    const { id, mode, quotas } = action;
    const idx = findIndex(propEq('id', id), draft.templates[mode].data);
    const newQuotas = quotas.map((item) => {
        const quota = find(propEq('quota_template_id', item.id), draft.templates[mode].data[idx].data.quotas);
        return { ...item, ...quota };
    });
    draft.templates[mode].data[idx].data.quotas = newQuotas;
    draft.status = removeStatus('pending-dqt', draft.status);
});
const quotatemplatesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dqt', draft.status);
});

const trainingscheduledetailRequest = produce((draft, action) => {
    draft.status.push('pending-dts');
    draft.trainingScheduleDetail = null;
});
const trainingscheduledetailSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dts', draft.status);
    draft.trainingScheduleDetail = action.response;
});
const trainingscheduledetailFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dts', draft.status);
    draft.trainingScheduleDetail = action.response;
});

const traininglistRequest = produce((draft, action) => {
    draft.status.push('pending-dtl');
});
const traininglistSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dtl', draft.status);
    draft.trainingSchedules = action.response;
});
const traininglistFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dtl', draft.status);
});

const librarytemplatesaveRequest = produce((draft, action) => {
    draft.status.push('pending-dly');
});
const librarytemplatesaveSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dly', draft.status);
});
const librarytemplatesaveFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dly', draft.status);
});

const librarycardtemplatesRequest = produce((draft, action) =>
    produce((draft, action) => {
        draft.status.push('pending-dla');
        draft.libraryCardTemplates = [];
    })
);
const librarycardtemplatesSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dla', draft.status);
    draft.libraryCardTemplates = action.response;
});
const librarycardtemplatesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dla', draft.status);
});

const createquotaRequest = produce((draft, action) => {
    draft.status.push('pending-dcq');
});
const createquotaSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dcq', draft.status);
});
const createquotaFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dcq', draft.status);
});

// Hiroki removed status changes because it would make some troubles in library/program detail.
// https://drivingsales.atlassian.net/browse/TOP-3171
const getquotaoptionsRequest = produce((draft, action) => {
    draft.status.push('pending-dga');
});
const getquotaoptionsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dga', draft.status);
    draft.libraryQuotaOptions = action.response;
});
const getquotaoptionsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dga', draft.status);
});

const adddocumentRequest = produce((draft, action) => {
    draft.status.push('pending-dad');
});
const adddocumentSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dad', draft.status);
});
const adddocumentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dad', draft.status);
});

const deletedocumentRequest = produce((draft, action) => {
    draft.status.push('pending-ddd');
});
const deletedocumentSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-ddd', draft.status);
});
const deletedocumentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ddd', draft.status);
});

const careergoalsRequest = produce((draft, action) => {
    draft.status.push('pending-dcg');
});
const careergoalsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dcg', draft.status);
    draft.careerGoals = action.response;
});
const careergoalsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dcg', draft.status);
});

const careergoalsaveRequest = produce((draft, action) => {
    draft.status.push('pending-dcr');
});
const careergoalsaveSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dcr', draft.status);
    draft.careerGoals = action.response;
});
const careergoalsaveFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dcr', draft.status);
});

const careerdevreportsRequest = produce((draft, action) => {
    draft.status.push('pending-dcd');
});
const careerdevreportsSuccess = produce((draft, action) => {
    const { programs, requirements, habits, developments, current, jobs, message } = action.response;
    draft.status = removeStatus('pending-dcd', draft.status);
    draft.careerMessage = message;
    draft.careerJobs = jobs;
    draft.careerCurJobIndex = current;
    draft.careerPrograms = programs;
    draft.careerRequirements = requirements;
    draft.careerHabits = habits;
    draft.careerDevelopments = developments;
});
const careerdevreportsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dcd', draft.status);
});

const careertasksRequest = produce((draft, action) => {
    draft.status.push('pending-dct');
});
const careertasksSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dct', draft.status);
    draft.careerTasks = action.response.data;
});
const careertasksFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dct', draft.status);
});

const careertrainingsRequest = produce((draft, action) => {
    draft.status.push('pending-dca');
});
const careertrainingsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dca', draft.status);
    draft.careerTrainings = action.response.data;
});
const careertrainingsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dca', draft.status);
});

const careerpromoteRequest = produce((draft, action) => {
    draft.careerPromotionCard = {};
    career.promoteStatus = 'requested';
});
const careerpromoteSuccess = produce((draft, action) => {
    draft.careerPromotionCard = action.response;
    draft.promoteStatus = 'promoted';
});
const careerpromoteFailure = produce((draft, action) => {
    draft.promoteStatus = 'error';
});

const userscoursereportRequest = produce((draft, action) => {
    draft.status.push('pending-dus');
});
const userscoursereportSuccess = produce((draft, action) => {
    const { response } = action;
    const selfsCoursesReport = [];
    const careerCoursesReport = [];
    const managerCoursesReport = [];
    response.map((item) => {
        if (item.category == 'self') {
            selfsCoursesReport.push(item);
        } else if (item.category == 'manager') {
            managerCoursesReport.push(item);
        } else {
            careerCoursesReport.push(item);
        }
    });
    draft.status = removeStatus('pending-dus', draft.status);
    draft.selfsCoursesReport = selfsCoursesReport;
    draft.careerCoursesReport = careerCoursesReport;
    draft.managerCoursesReport = managerCoursesReport;
});
const userscoursereportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dus', draft.status);
});

const teamreportsRequest = produce((draft, action) => {
    draft.status.push('pending-dtr');
});
const teamreportsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dtr', draft.status);
    draft.teamReports = action.response;
});
const teamreportsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dtr', draft.status);
});

const adddevcommentRequest = produce((draft, action) => {
    draft.status.push('pending-dae');
});
const adddevcommentSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dae', draft.status);
});
const adddevcommentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dae', draft.status);
});

const postcompanyinfoRequest = produce((draft, action) => {
    draft.status.push('pending-dpc');
});
const postcompanyinfoSuccess = produce((draft, action) => {
    draft.status.push('pending-dpc');
});
const postcompanyinfoFailure = produce((draft, action) => {
    draft.status.push('pending-dpc');
});

const fetchnotificationssettingsRequest = produce((draft, action) => {
    draft.status.push('pending-dfn');
});
const fetchnotificationssettingsSuccess = produce((draft, action) => {
    const { message } = action.response;
    draft.status = removeStatus('pending-dfn', draft.status);
    if (message !== 'User notification setting not found!!') {
        draft.notificationsSettings = action.response.notification_settings;
    } else {
        draft.notificationsSettings = INITIAL_NOTIFICATION_SETTINGS;
    }
});
const fetchnotificationssettingsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dfn', draft.status);
});

const updatenotificationssettingsRequest = produce((draft, action) => {
    draft.status.push('pending-dun');
});
const updatenotificationssettingsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dun', draft.status);
    draft.notificationsSettings = action.response.notification_settings;
});
const updatenotificationssettingsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dun', draft.status);
});

const postterminateuserRequest = produce((draft, action) => {
    draft.status.push('pending-dpu');
});
const postterminateuserSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dpu', draft.status);
});
const postterminateuserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dpu', draft.status);
});

const postdeleteuserRequest = produce((draft, action) => {
    draft.status.push('pending-dpr');
});
const postdeleteuserSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dpr', draft.status);
});
const postdeleteuserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dpr', draft.status);
});

const videostateRequest = produce((draft, action) => {
    const { id } = action.cardState;
    const videos = draft.videoPlayStates || [];
    const videoIdx = findIndex(propEq('id', id), videos);
    if (videoIdx > -1) {
        videos[videoIdx] = action.cardState;
    } else {
        videos.push(action.cardState);
    }
    draft.videoPlayStates = videos;
});

const notificationsetRequest = produce((draft, action) => {
    const notificationArray = action.index;
    if (notificationArray && notificationArray.length > 0) {
        draft.notificationToggle = notificationArray;
    } else {
        draft.notificationToggle = [];
    }
});

const getuserprogramsRequest = produce((draft, action) => {
    draft.status.push('pending-dup');
});
const getuserprogramsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dup', draft.status);
    draft.instances.programs = action.response;
});
const getuserprogramsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dup', draft.status);
});

const getuserscorecardsRequest = produce((draft, action) => {
    draft.status.push('pending-dusc');
});
const getuserscorecardsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dusc', draft.status);
    draft.instances.scorecards = action.response;
});
const getuserscorecardsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dusc', draft.status);
});

const getassessmentsRequest = produce((draft, action) => {
    draft.status.push('pending-dar');
});
const getassessmentsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-dar', draft.status);
    draft.templates.assessments = action.response;
});
const getassessmentsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dar', draft.status);
});

const resetRequest = produce((draft) => {
    draft.status = [];
});

const clearRequest = produce((draft, action) => (draft = { ...initialState, videoPlayStates: draft.videoPlayStates }));

export const reducer = createReducer(initialState, {
    [DevelopTypes.GETLEARNFEEDS_REQUEST]: getlearnfeedsRequest,
    [DevelopTypes.GETLEARNFEEDS_SUCCESS]: getlearnfeedsSuccess,
    [DevelopTypes.GETLEARNFEEDS_FAILURE]: getlearnfeedsFailure,

    [DevelopTypes.POSTLIBRARYCARDTEMPLATES_REQUEST]: postlibrarycardtemplatesRequest,
    [DevelopTypes.POSTLIBRARYCARDTEMPLATES_SUCCESS]: postlibrarycardtemplatesSuccess,
    [DevelopTypes.POSTLIBRARYCARDTEMPLATES_FAILURE]: postlibrarycardtemplatesFailure,

    [DevelopTypes.GETLIBRARYTEMPLATES_REQUEST]: getlibrarytemplatesRequest,
    [DevelopTypes.GETLIBRARYTEMPLATES_SUCCESS]: getlibrarytemplatesSuccess,
    [DevelopTypes.GETLIBRARYTEMPLATES_FAILURE]: getlibrarytemplatesFailure,

    [DevelopTypes.GETLIBRARYTEMPLATESSEARCH_REQUEST]: getlibrarytemplatessearchRequest,
    [DevelopTypes.GETLIBRARYTEMPLATESSEARCH_SUCCESS]: getlibrarytemplatessearchSuccess,
    [DevelopTypes.GETLIBRARYTEMPLATESSEARCH_FAILURE]: getlibrarytemplatessearchFailure,

    [DevelopTypes.DAILYTRAINING_REQUEST]: dailytrainingRequest,
    [DevelopTypes.DAILYTRAINING_SUCCESS]: dailytrainingSuccess,
    [DevelopTypes.DAILYTRAINING_FAILURE]: dailytrainingFailure,

    [DevelopTypes.UPDATECARD_REQUEST]: updatecardRequest,
    [DevelopTypes.UPDATECARD_SUCCESS]: updatecardSuccess,
    [DevelopTypes.UPDATECARD_FAILURE]: updatecardFailure,

    [DevelopTypes.GETSCORMLINK_REQUEST]: getscormlinkRequest,
    [DevelopTypes.GETSCORMLINK_SUCCESS]: getscormlinkSuccess,
    [DevelopTypes.GETSCORMLINK_FAILURE]: getscormlinkFailure,

    [DevelopTypes.POSTSCORECARDSAVE_REQUEST]: postscorecardsaveRequest,
    [DevelopTypes.POSTSCORECARDSAVE_SUCCESS]: postscorecardsaveSuccess,
    [DevelopTypes.POSTSCORECARDSAVE_FAILURE]: postscorecardsaveFailure,

    [DevelopTypes.QUESTION_REQUEST]: questionRequest,
    [DevelopTypes.QUESTION_SUCCESS]: questionSuccess,
    [DevelopTypes.QUESTION_FAILURE]: questionFailure,

    [DevelopTypes.ANSWER_REQUEST]: answerRequest,
    [DevelopTypes.ANSWER_SUCCESS]: answerSuccess,
    [DevelopTypes.ANSWER_FAILURE]: answerFailure,

    [DevelopTypes.RESETQUIZ_REQUEST]: resetquizRequest,
    [DevelopTypes.RESETQUIZ_SUCCESS]: resetquizSuccess,
    [DevelopTypes.RESETQUIZ_FAILURE]: resetquizFailure,

    // update module
    [DevelopTypes.UPDATEMODULE_REQUEST]: updatemoduleRequest,
    [DevelopTypes.UPDATEMODULE_SUCCESS]: updatemoduleSuccess,
    [DevelopTypes.UPDATEMODULE_FAILURE]: updatemoduleFailure,

    // get training schedule
    [DevelopTypes.TRAININGLIST_REQUEST]: traininglistRequest,
    [DevelopTypes.TRAININGLIST_SUCCESS]: traininglistSuccess,
    [DevelopTypes.TRAININGLIST_FAILURE]: traininglistFailure,

    // create/update library templates
    [DevelopTypes.LIBRARYTEMPLATESAVE_REQUEST]: librarytemplatesaveRequest,
    [DevelopTypes.LIBRARYTEMPLATESAVE_SUCCESS]: librarytemplatesaveSuccess,
    [DevelopTypes.LIBRARYTEMPLATESAVE_FAILURE]: librarytemplatesaveFailure,

    // save/delete template
    [DevelopTypes.LIBRARYEVENT_REQUEST]: libraryeventRequest,
    [DevelopTypes.LIBRARYEVENT_SUCCESS]: libraryeventSuccess,
    [DevelopTypes.LIBRARYEVENT_FAILURE]: libraryeventFailure,

    // create/update library modules
    [DevelopTypes.LIBRARYSAVE_REQUEST]: librarysaveRequest,
    [DevelopTypes.LIBRARYSAVE_SUCCESS]: librarysaveSuccess,
    [DevelopTypes.LIBRARYSAVE_FAILURE]: librarysaveFailure,

    // get card templates
    [DevelopTypes.LIBRARYCARDTEMPLATES_REQUEST]: librarycardtemplatesRequest,
    [DevelopTypes.LIBRARYCARDTEMPLATES_SUCCESS]: librarycardtemplatesSuccess,
    [DevelopTypes.LIBRARYCARDTEMPLATES_FAILURE]: librarycardtemplatesFailure,

    // get program detail
    [DevelopTypes.LIBRARYPROGRAMDETAIL_REQUEST]: libraryprogramdetailRequest,
    [DevelopTypes.LIBRARYPROGRAMDETAIL_SUCCESS]: libraryprogramdetailSuccess,
    [DevelopTypes.LIBRARYPROGRAMDETAIL_FAILURE]: libraryprogramdetailFailure,

    // program request promotion
    [DevelopTypes.PROGRAMPROMOTION_REQUEST]: programpromotionRequest,
    [DevelopTypes.PROGRAMPROMOTION_SUCCESS]: programpromotionSuccess,
    [DevelopTypes.PROGRAMPROMOTION_FAILURE]: programpromotionFailure,

    // get quota detail
    [DevelopTypes.QUOTATEMPLATES_REQUEST]: quotatemplatesRequest,
    [DevelopTypes.QUOTATEMPLATES_SUCCESS]: quotatemplatesSuccess,
    [DevelopTypes.QUOTATEMPLATES_FAILURE]: quotatemplatesFailure,

    // get training schedule detail
    [DevelopTypes.TRAININGSCHEDULEDETAIL_REQUEST]: trainingscheduledetailRequest,
    [DevelopTypes.TRAININGSCHEDULEDETAIL_SUCCESS]: trainingscheduledetailSuccess,
    [DevelopTypes.TRAININGSCHEDULEDETAIL_FAILURE]: trainingscheduledetailFailure,

    // create Quota
    [DevelopTypes.CREATEQUOTA_REQUEST]: createquotaRequest,
    [DevelopTypes.CREATEQUOTA_SUCCESS]: createquotaSuccess,
    [DevelopTypes.CREATEQUOTA_FAILURE]: createquotaFailure,

    [DevelopTypes.GETQUOTAOPTIONS_REQUEST]: getquotaoptionsRequest,
    [DevelopTypes.GETQUOTAOPTIONS_SUCCESS]: getquotaoptionsSuccess,
    [DevelopTypes.GETQUOTAOPTIONS_FAILURE]: getquotaoptionsFailure,

    // add Document
    [DevelopTypes.ADDDOCUMENT_REQUEST]: adddocumentRequest,
    [DevelopTypes.ADDDOCUMENT_SUCCESS]: adddocumentSuccess,
    [DevelopTypes.ADDDOCUMENT_FAILURE]: adddocumentFailure,

    // delete Document
    [DevelopTypes.DELETEDOCUMENT_REQUEST]: deletedocumentRequest,
    [DevelopTypes.DELETEDOCUMENT_SUCCESS]: deletedocumentSuccess,
    [DevelopTypes.DELETEDOCUMENT_FAILURE]: deletedocumentFailure,

    // Career Page
    // Career Goals
    [DevelopTypes.CAREERGOALS_REQUEST]: careergoalsRequest,
    [DevelopTypes.CAREERGOALS_SUCCESS]: careergoalsSuccess,
    [DevelopTypes.CAREERGOALS_FAILURE]: careergoalsFailure,

    [DevelopTypes.CAREERGOALSAVE_REQUEST]: careergoalsaveRequest,
    [DevelopTypes.CAREERGOALSAVE_SUCCESS]: careergoalsaveSuccess,
    [DevelopTypes.CAREERGOALSAVE_FAILURE]: careergoalsaveFailure,

    // Career Reports
    [DevelopTypes.CAREERDEVREPORTS_REQUEST]: careerdevreportsRequest,
    [DevelopTypes.CAREERDEVREPORTS_SUCCESS]: careerdevreportsSuccess,
    [DevelopTypes.CAREERDEVREPORTS_FAILURE]: careerdevreportsFailure,

    // Career Tasks
    [DevelopTypes.CAREERTASKS_REQUEST]: careertasksRequest,
    [DevelopTypes.CAREERTASKS_SUCCESS]: careertasksSuccess,
    [DevelopTypes.CAREERTASKS_FAILURE]: careertasksFailure,

    // Career Training
    [DevelopTypes.CAREERTRAININGS_REQUEST]: careertrainingsRequest,
    [DevelopTypes.CAREERTRAININGS_SUCCESS]: careertrainingsSuccess,
    [DevelopTypes.CAREERTRAININGS_FAILURE]: careertrainingsFailure,

    // Career Promotion
    [DevelopTypes.CAREERPROMOTE_REQUEST]: careerpromoteRequest,
    [DevelopTypes.CAREERPROMOTE_SUCCESS]: careerpromoteSuccess,
    [DevelopTypes.CAREERPROMOTE_FAILURE]: careerpromoteFailure,

    // Add Comment
    [DevelopTypes.ADDDEVCOMMENT_REQUEST]: adddevcommentRequest,
    [DevelopTypes.ADDDEVCOMMENT_SUCCESS]: adddevcommentSuccess,
    [DevelopTypes.ADDDEVCOMMENT_FAILURE]: adddevcommentFailure,

    // Users courses Reports
    [DevelopTypes.USERSCOURSEREPORT_REQUEST]: userscoursereportRequest,
    [DevelopTypes.USERSCOURSEREPORT_SUCCESS]: userscoursereportSuccess,
    [DevelopTypes.USERSCOURSEREPORT_FAILURE]: userscoursereportFailure,

    // Team Development Reports
    [DevelopTypes.TEAMREPORTS_REQUEST]: teamreportsRequest,
    [DevelopTypes.TEAMREPORTS_SUCCESS]: teamreportsSuccess,
    [DevelopTypes.TEAMREPORTS_FAILURE]: teamreportsFailure,

    // Notifications settings
    [DevelopTypes.FETCHNOTIFICATIONSSETTINGS_REQUEST]: fetchnotificationssettingsRequest,
    [DevelopTypes.FETCHNOTIFICATIONSSETTINGS_SUCCESS]: fetchnotificationssettingsSuccess,
    [DevelopTypes.FETCHNOTIFICATIONSSETTINGS_FAILURE]: fetchnotificationssettingsFailure,

    [DevelopTypes.UPDATENOTIFICATIONSSETTINGS_REQUEST]: updatenotificationssettingsRequest,
    [DevelopTypes.UPDATENOTIFICATIONSSETTINGS_SUCCESS]: updatenotificationssettingsSuccess,
    [DevelopTypes.UPDATENOTIFICATIONSSETTINGS_FAILURE]: updatenotificationssettingsFailure,

    [DevelopTypes.POSTCOMPANYINFO_REQUEST]: postcompanyinfoRequest,
    [DevelopTypes.POSTCOMPANYINFO_SUCCESS]: postcompanyinfoSuccess,
    [DevelopTypes.POSTCOMPANYINFO_FAILURE]: postcompanyinfoFailure,

    [DevelopTypes.POSTTERMINATEUSER_REQUEST]: postterminateuserRequest,
    [DevelopTypes.POSTTERMINATEUSER_SUCCESS]: postterminateuserSuccess,
    [DevelopTypes.POSTTERMINATEUSER_FAILURE]: postterminateuserFailure,

    [DevelopTypes.POSTDELETEUSER_REQUEST]: postdeleteuserRequest,
    [DevelopTypes.POSTDELETEUSER_SUCCESS]: postdeleteuserSuccess,
    [DevelopTypes.POSTDELETEUSER_FAILURE]: postdeleteuserFailure,

    [DevelopTypes.GETASSESSMENTS_REQUEST]: getassessmentsRequest,
    [DevelopTypes.GETASSESSMENTS_SUCCESS]: getassessmentsSuccess,
    [DevelopTypes.GETASSESSMENTS_FAILURE]: getassessmentsFailure,

    [DevelopTypes.GETUSERPROGRAMS_REQUEST]: getuserprogramsRequest,
    [DevelopTypes.GETUSERPROGRAMS_SUCCESS]: getuserprogramsSuccess,
    [DevelopTypes.GETUSERPROGRAMS_FAILURE]: getuserprogramsFailure,

    [DevelopTypes.GETUSERSCORECARDS_REQUEST]: getuserscorecardsRequest,
    [DevelopTypes.GETUSERSCORECARDS_SUCCESS]: getuserscorecardsSuccess,
    [DevelopTypes.GETUSERSCORECARDS_FAILURE]: getuserscorecardsFailure,

    [DevelopTypes.VIDEOSTATE_REQUEST]: videostateRequest,

    [DevelopTypes.NOTIFICATIONSET_REQUEST]: notificationsetRequest,

    [DevelopTypes.RESET_REQUEST]: resetRequest,

    [DevelopTypes.CLEAR_REQUEST]: clearRequest,
});
